import { useTheme } from "@catchoftheday/theme";
import { minusOnePx, useMedia } from "@catchoftheday/utilities";

export const useIsTabletView = () => {
  const theme = useTheme();
  return useMedia<boolean>(
    [
      `(min-width: ${theme.breakpoints.md}) and (max-width: ${minusOnePx(
        theme.breakpoints.lg,
        true
      )})`,
    ],
    [true]
  );
};
